import { CORE_INPUT_TEXT_DISPLAY_NAME } from "./core";
import createTestId from "../../../../fabrics/createTestId";

export const createTestIdForCoreInputTextElement = createTestId(
    CORE_INPUT_TEXT_DISPLAY_NAME,
);
